module.exports = __webpack_public_path__ + "resource/img/PaleGreen.85e4ec91.png";